import { render, staticRenderFns } from "./allselected2.vue?vue&type=template&id=5168628e&scoped=true&"
import script from "./allselected2.vue?vue&type=script&lang=js&"
export * from "./allselected2.vue?vue&type=script&lang=js&"
import style0 from "./allselected2.vue?vue&type=style&index=0&id=5168628e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5168628e",
  null
  
)

export default component.exports